import React, {
  createContext, useEffect, useState
} from 'react';

import { APIClient } from '../client';
import { useIndex } from '../hooks';

export const BeneficiariesContext = createContext({ beneficiaries: [], loading: false, update: () => {} });

export function BeneficiariesProvider({ assetId, children }) {
  console.log('BeneficiariesProvider', assetId);
  const { data, loading, update } = useIndex('bequests', { asset_id: assetId }, !assetId);
  const [ beneficiaries, setBeneficiaries ] = useState([]);

  useEffect(() => {
    if (!data)
      return;
    
    const getPeople = async () => {
      const client = new APIClient('api/people');
      const result = await Promise.all(data.map(bequest => {
        return client.show(bequest.beneficiaryId);
      }));

      setBeneficiaries(result);
    };
    getPeople();
  },  [ data ]);

  if (loading) {
    return <div>Loading beneficiaries for asset {assetId}...</div>;
  }

  return (
    <BeneficiariesContext.Provider value={{ beneficiaries: beneficiaries, loading, update }}>
      {children}
    </BeneficiariesContext.Provider>
  );
}
